// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-9da11bd6]{display:none}.sf-dropdown[data-v-9da11bd6]{--dropdown-position:static;--dropdown-container-position:absolute;--dropdown-container-top:33px;--list-item-padding:3px 0}[data-v-9da11bd6] .sf-dropdown__container{border-top:1px solid var(--c-black);border-bottom-left-radius:10px;border-bottom-right-radius:10px;box-sizing:border-box;padding:12px 15px}.acc__label[data-v-9da11bd6]{margin-left:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
